import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["name", "id"]
const _hoisted_2 = {
  key: 0,
  class: "text-grey"
}
const _hoisted_3 = {
  key: 0,
  class: "text-grey"
}
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Highlighter = _resolveComponent("Highlighter")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_PropertiesListCriterion = _resolveComponent("PropertiesListCriterion")!
  const _component_Acceptability = _resolveComponent("Acceptability")!

  return (_openBlock(), _createElementBlock("tr", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hasMany ? _ctx.showDetails = !_ctx.showDetails : '')),
    key: `${_ctx.property}-${_ctx.criterionItems.length}-${_ctx.aimItems.length}`
  }, [
    _createElementVNode("td", null, [
      _createElementVNode("a", {
        name: `${_ctx.property}`,
        id: _ctx.property
      }, null, 8, _hoisted_1),
      _createElementVNode("b", null, [
        _createVNode(_component_Highlighter, {
          searchWords: [_ctx.state.searchInput],
          textToHighlight: _ctx.property ?? ''
        }, null, 8, ["searchWords", "textToHighlight"])
      ]),
      (_ctx.criterionItems.length > 1 || _ctx.aimItems.length > 1)
        ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.showDetails ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", null, [
      (_ctx.criterionItems.length > 1 && !_ctx.showDetails)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.criterionItems.length) + " criteria ", 1))
        : _createCommentVNode("", true),
      (_ctx.criterionItems.length <= 1 || (_ctx.criterionItems.length > 1 && _ctx.showDetails))
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.criterionItems, (item, index) => {
            return (_openBlock(), _createBlock(_component_PropertiesListCriterion, {
              key: index,
              item: item,
              row: _ctx.getAimsCountFromAimsAndCriterion(_ctx.getAimsFromItems(_ctx.items), item.criterion)
            }, null, 8, ["item", "row"]))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", null, [
      (_ctx.aimItems.length > 1 && !_ctx.showDetails)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.aimItems.length) + " aims", 1))
        : _createCommentVNode("", true),
      (_ctx.aimItems.length <= 1 || (_ctx.aimItems.length > 1 && _ctx.showDetails))
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.aimItems, (argument, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_ctx.getAimById(argument.aim).name), 1))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.c_alternativesIds, (alternativeId, index) => {
      return (_openBlock(), _createElementBlock("td", { key: index }, [
        (!_ctx.showDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_Acceptability, {
                items: _ctx.filterItemsBy(_ctx.items, {
                alternative: alternativeId
            }),
                alternative: alternativeId,
                icon: false
              }, null, 8, ["items", "alternative"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetails)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.aimItems, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "text-center",
                key: index
              }, [
                _createVNode(_component_Acceptability, {
                  items: _ctx.filterItemsBy(_ctx.items, {
                alternative: alternativeId,
                aim: item.aim
            }),
                  alternative: alternativeId,
                  icon: false
                }, null, 8, ["items", "alternative"])
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}